import React from 'react';
import { FaLinkedin, FaGithub, FaWhatsapp } from 'react-icons/fa';
import { SiGmail } from 'react-icons/si';
import { FiArrowUpRight } from 'react-icons/fi';

function Contact({ mode }) {
    const contactLinks = [
        {
            name: 'GitHub',
            handle: '@basharatsahito',
            description: 'Explore open-source repos & codebases',
            icon: <FaGithub size={26} />,
            url: 'https://github.com/basharatsahito',
            accentLight: '#24292e',
            accentDark: '#f0f6fc', // Crisp white/light-gray in dark mode
        },
        {
            name: 'LinkedIn',
            handle: 'Basharat Ali Sahito',
            description: 'Professional experience & networking',
            icon: <FaLinkedin size={26} />,
            url: 'https://www.linkedin.com/in/basharat-ali-sahito/',
            accentLight: '#0a66c2',
            accentDark: '#38bdf8', // Bright blue pop in dark mode
        },
        {
            name: 'Gmail',
            handle: 'basharataliali3@gmail.com',
            description: 'Direct inquiries & business emails',
            icon: <SiGmail size={26} />,
            url: 'https://mail.google.com/mail/?view=cm&fs=1&to=basharataliali3@gmail.com',
            accentLight: '#ea4335',
            accentDark: '#f87171', // Bright vibrant red in dark mode
        },
        {
            name: 'WhatsApp',
            handle: '03329835553',
            description: 'Instant messaging & quick calls',
            icon: <FaWhatsapp size={26} />,
            url: 'https://wa.me/923329835553',
            accentLight: '#25d366',
            accentDark: '#4ade80', // Bright emerald green in dark mode
        },
    ];

    return (
        <div className="container section-card py-5">
            <div className="section-heading text-center mb-5">
                <p className="section-title">Connect With Me</p>
                <p className="section-subtitle">
                    Reach out for collaborations, interviews, or new product opportunities.
                </p>
            </div>

            {/* 4-Column Layout on Desktop, Responsive Auto-Grid */}
            <div className="contact-grid">
                {contactLinks.map((item) => (
                    <a
                        key={item.name}
                        href={item.url}
                        target="_blank"
                        rel="noreferrer"
                        className="contact-card"
                        style={{
                            '--accent-light': item.accentLight,
                            '--accent-dark': item.accentDark,
                        }}
                    >
                        <div className="contact-card-header">
                            <div className="contact-icon-wrapper">
                                {item.icon}
                            </div>
                            <div className="contact-arrow">
                                <FiArrowUpRight size={20} />
                            </div>
                        </div>

                        <div className="contact-card-body">
                            <h3 className="contact-name">{item.name}</h3>
                            <p className="contact-handle">{item.handle}</p>
                            <p className="contact-desc">{item.description}</p>
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
}

export default Contact;